import { render, staticRenderFns } from "./TinySpinner.vue?vue&type=template&id=1d67dd66&scoped=true&"
import script from "./TinySpinner.vue?vue&type=script&lang=ts&"
export * from "./TinySpinner.vue?vue&type=script&lang=ts&"
import style0 from "./TinySpinner.vue?vue&type=style&index=0&id=1d67dd66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d67dd66",
  null
  
)

export default component.exports